import React, {useEffect, useState} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {authStorage, ensureAuthenticated} from '../../services/api';

export default function PublicOnlyRoute() {
    const [authState, setAuthState] = useState(() => authStorage.isAuthenticated() ? 'authenticated' : 'checking');

    useEffect(() => {
        let active = true;
        const restoreSession = async () => {
            const authenticated = await ensureAuthenticated();
            if (active) setAuthState(authenticated ? 'authenticated' : 'anonymous');
        };
        const syncAuth = () => {
            if (authStorage.isAuthenticated()) setAuthState('authenticated');
            else if (authStorage.get().refresh) { setAuthState('checking'); restoreSession(); }
            else setAuthState('anonymous');
        };
        window.addEventListener('auth-change', syncAuth);
        window.addEventListener('storage', syncAuth);
        restoreSession();
        return () => {
            active = false;
            window.removeEventListener('auth-change', syncAuth);
            window.removeEventListener('storage', syncAuth);
        };
    }, []);

    if (authState === 'checking') return <div className="api-message">در حال بررسی نشست کاربری...</div>;
    const destination = authStorage.getRole() === 'student' ? '/exampage' : '/dashboard';
    return authState === 'authenticated' ? <Navigate to={destination} replace/> : <Outlet/>;
}
